<div class="layout-topbar">
    <div class="logo">
        <a [routerLink]="['/dashboard']">
            <!-- <img class="logo big" src="assets/new_osto/full_logo_white.png" alt="prestige-layout" />
            <img class="logo small" src="assets/new_osto/osto_logo-white.png" alt="prestige-layout" /> -->
            <div class="logo-svg">
                <svg width="153" height="32" viewBox="0 0 153 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M138.182 8.4043C137.356 8.4043 136.824 8.92769 136.824 9.7412V13.5755L136.573 13.3422C135.66 12.4928 134.491 12.0621 133.103 12.0621C129.834 12.0621 127.552 14.4368 127.552 17.8374C127.552 21.238 130.077 23.5977 133.555 23.5977C137.033 23.5977 139.522 21.1752 139.522 17.8374V9.7412C139.522 8.94265 138.983 8.4043 138.182 8.4043ZM133.576 21.5401C131.623 21.5401 130.31 20.0536 130.31 17.8374C130.31 15.6212 131.623 14.1168 133.576 14.1168C135.529 14.1168 136.824 15.6122 136.824 17.8374C136.824 20.0626 135.52 21.5401 133.576 21.5401Z"
                        fill="white" />
                    <path
                        d="M124.693 8.4043C123.868 8.4043 123.336 8.92769 123.336 9.7412V13.5755L123.084 13.3422C122.172 12.4928 121.003 12.0621 119.612 12.0621C116.343 12.0621 114.061 14.4368 114.061 17.8374C114.061 21.238 116.585 23.5977 120.067 23.5977C123.548 23.5977 126.03 21.1752 126.03 17.8374V9.7412C126.03 8.94265 125.492 8.4043 124.693 8.4043ZM120.088 21.5401C118.132 21.5401 116.819 20.0536 116.819 17.8374C116.819 15.6212 118.132 14.1168 120.088 14.1168C122.044 14.1168 123.336 15.6122 123.336 17.8374C123.336 20.0626 122.032 21.5401 120.088 21.5401Z"
                        fill="white" />
                    <path
                        d="M111.289 12.0625C110.451 12.0625 109.931 12.5739 109.931 13.3994V18.9534C109.931 20.4638 108.746 21.5614 107.116 21.5614C105.486 21.5614 104.383 20.4817 104.383 18.9953V13.3994C104.383 12.6128 103.832 12.0625 103.046 12.0625C102.208 12.0625 101.688 12.5739 101.688 13.3994V19.4917C101.688 21.9083 103.632 23.5982 106.414 23.5982C107.634 23.5982 108.794 23.1764 109.682 22.4138L109.883 22.2403L109.925 22.5035C110.035 23.1794 110.541 23.5982 111.244 23.5982C112.081 23.5982 112.622 23.0718 112.622 22.2583V13.3994C112.622 12.6008 112.084 12.0625 111.286 12.0625H111.289Z"
                        fill="white" />
                    <path
                        d="M97.5182 15.5763L97.261 15.4597L97.5033 15.3131C98.574 14.6671 99.1871 13.6233 99.1871 12.4479C99.1871 10.1061 96.8872 8.4043 93.7199 8.4043C90.5526 8.4043 88.2915 10.4321 88.2915 13.3362V18.6659C88.2915 21.57 90.6662 23.5977 94.0698 23.5977C97.4734 23.5977 99.869 21.7225 99.869 19.1414C99.869 17.5622 99.0137 16.2642 97.5182 15.5763ZM91.2345 13.3362C91.2345 11.7421 92.2783 10.5846 93.7199 10.5846C95.1615 10.5846 96.1604 11.437 96.1604 12.6124C96.1604 13.7878 95.0448 14.703 93.4507 14.703H91.2345V13.3362ZM94.0698 21.4174C92.4278 21.4174 91.2345 20.26 91.2345 18.6659V16.4915H93.8844C95.637 16.4915 96.8632 17.5114 96.8632 18.9739C96.8632 20.4364 95.6878 21.4174 94.0698 21.4174Z"
                        fill="white" />
                    <path
                        d="M80.7667 12.0625C77.3601 12.0625 74.8867 14.4911 74.8867 17.8378C74.8867 21.1846 77.3601 23.5982 80.7667 23.5982C84.1733 23.5982 86.6706 21.1756 86.6706 17.8378C86.6706 14.5 84.1882 12.0625 80.7667 12.0625ZM80.7667 21.5405C78.9004 21.5405 77.6443 20.054 77.6443 17.8378C77.6443 15.6216 78.9273 14.1172 80.7667 14.1172C82.6061 14.1172 83.9101 15.6126 83.9101 17.8378C83.9101 20.063 82.6479 21.5405 80.7667 21.5405Z"
                        fill="white" />
                    <path
                        d="M73.1019 21.1692C71.5317 21.1692 70.3503 20.0297 70.3503 18.5193V14.0749H73.0839C73.6193 14.0749 73.9662 13.728 73.9662 13.1926C73.9662 12.6573 73.6193 12.2685 73.0839 12.2685H70.3503V9.78307C70.3503 8.97256 69.8 8.4043 69.0134 8.4043C68.2268 8.4043 67.6555 8.96657 67.6555 9.7412V12.2685H66.3276C65.7833 12.2685 65.4453 12.6064 65.4453 13.1508C65.4453 13.6951 65.7833 14.0749 66.3276 14.0749H67.6555V18.8722C67.6555 21.6118 69.5487 23.5977 72.1538 23.5977H73.1019C73.9154 23.5977 74.4417 23.1132 74.4417 22.3625C74.4417 21.6118 73.9034 21.1692 73.1019 21.1692Z"
                        fill="white" />
                    <path
                        d="M60.1208 13.8689C61.3171 13.8689 62.2802 14.6047 62.4746 15.6604C62.669 15.9804 63.0668 16.1449 63.653 16.1449C63.9939 16.1449 64.7835 16.0672 64.7835 15.3464C64.7416 13.5369 62.5673 12.0654 59.9354 12.0654C57.1359 12.0654 55.0244 13.5279 55.0244 15.466C55.0244 17.8198 57.2376 18.2236 59.1907 18.5795C60.6771 18.8516 61.9632 19.0849 61.9632 20.1556C61.9632 21.0858 60.9822 21.8126 59.729 21.8126C58.4758 21.8126 57.5248 21.0619 57.3333 20.0211C57.133 19.6891 56.7501 19.5216 56.1968 19.5216C55.8439 19.5216 55.0244 19.5993 55.0244 20.3171C55.0633 22.1266 57.2646 23.6011 59.9354 23.6011C62.7438 23.6011 64.7835 22.1685 64.7835 20.1975C64.7835 17.8497 62.5763 17.4489 60.6263 17.096C59.1308 16.8239 57.8418 16.5906 57.8418 15.5079C57.8418 14.5747 58.8228 13.8719 60.1208 13.8719V13.8689Z"
                        fill="white" />
                    <path
                        d="M45.7227 8.4043C41.2365 8.4043 37.9824 11.5985 37.9824 16.001C37.9824 20.4035 41.2365 23.5977 45.7227 23.5977C50.209 23.5977 53.4421 20.4035 53.4421 16.001C53.4421 11.5985 50.197 8.4043 45.7227 8.4043ZM45.7227 21.2918C42.9024 21.2918 41.0091 19.1653 41.0091 16.001C41.0091 12.8367 42.9024 10.7072 45.7227 10.7072C48.5431 10.7072 50.4153 12.8846 50.4153 16.001C50.4153 19.1175 48.4862 21.2918 45.7227 21.2918Z"
                        fill="white" />
                    <path
                        d="M151.598 12.002C151.114 12.002 150.668 12.2832 150.45 12.7258L146.84 20.7532L143.173 12.7138C142.952 12.2772 142.512 11.999 142.031 11.999H142.016C141.056 11.999 140.433 13.0339 140.867 13.9102L145.533 23.3373L145.318 23.8786C144.899 24.8118 144.573 25.0181 143.957 25.2006C143.628 25.2903 143.206 25.3412 142.769 25.3412H142.572C141.92 25.3412 141.391 25.8825 141.391 26.5524C141.391 27.2224 141.92 27.7637 142.572 27.7637H142.748C144.205 27.7637 145.189 27.659 145.919 27.1267C146.553 26.6481 147.073 26.0859 147.77 24.3572L152.756 13.8952C153.171 13.0219 152.549 12.002 151.598 12.002Z"
                        fill="white" />
                    <path
                        d="M22.4487 16.0029C22.4487 12.4468 19.5566 9.55469 16.0005 9.55469C12.4444 9.55469 9.55225 12.4468 9.55225 16.0029C9.55225 19.559 12.4444 22.4512 16.0005 22.4512C19.5566 22.4512 22.4487 19.559 22.4487 16.0029ZM12.896 16.0029C12.896 14.2922 14.2897 12.8984 16.0005 12.8984C17.7113 12.8984 19.105 14.2922 19.105 16.0029C19.105 17.7137 17.7113 19.1074 16.0005 19.1074C14.2897 19.1074 12.896 17.7137 12.896 16.0029Z"
                        fill="white" />
                    <path
                        d="M31.9299 14.4816C31.2091 6.74434 24.8715 0.568259 17.1193 0.0388809C16.7424 0.0149542 16.3686 0 16.0007 0C15.6328 0 15.259 0.0149542 14.8821 0.0388809C7.12987 0.568259 0.792292 6.74434 0.0715003 14.4816C-0.0571057 15.8484 -0.00925228 23.7891 0.191134 25.0782C0.496199 27.0162 3.34348 26.8158 3.34348 24.8539V16.001C3.34348 9.02336 9.02308 3.34376 16.0007 3.34376C22.9783 3.34376 28.6579 9.02336 28.6579 16.001V24.8539C28.6579 26.8158 31.5052 27.0162 31.8103 25.0782C32.0106 23.7891 32.0585 15.8484 31.9299 14.4816Z"
                        fill="white" />
                    <path
                        d="M22.7732 26.6913C20.8112 27.9384 18.4873 28.6592 15.999 28.6592C13.5106 28.6592 11.1867 27.9384 9.2277 26.6913C8.12707 25.9914 6.68848 26.8079 6.68848 28.1119C6.68848 28.6861 6.98457 29.2215 7.46908 29.5296C9.93653 31.0938 12.8616 32 15.996 32C19.1304 32 22.0584 31.0938 24.5288 29.5296C25.0133 29.2215 25.3124 28.6861 25.3124 28.1119C25.3124 26.8049 23.8738 25.9884 22.7732 26.6883V26.6913Z"
                        fill="white" />
                </svg>

            </div>
        </a>
    </div>
    <!-- <a class="layout-menu-button" href="#" (click)="app.onMenuButtonClick($event)">
        <i class="pi pi-bars"></i>
    </a> -->
    <!-- <li app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"></li> -->
    <div class="menu-items" *ngFor="let item of model; let i = index;">
        <button *ngIf="!isMobileMenuActive && !isMobile && item.label !== 'Admin'" pButton class="menu-item"
            [ngClass]="{'active-button': isBtnActive[item.routerLink[0]]}" [label]="item.label" size="small"
            (click)="menuItemSelected(item)">
            <img [src]="item.icon" alt="" class="tag-icon" [style]="{'margin-right': '3px'}">
        </button>
        <button *ngIf="!isMobileMenuActive && !isMobile && item.label === 'Admin'" pButton class="menu-item"
            [ngClass]="{'active-button': isBtnActive[item.routerLink[0]]}" [label]="item.label" size="small"
            (click)="ab.toggle($event)"><img [src]="item.icon" alt="" class="tag-icon"
                [style]="{'margin-right': '3px'}">
        </button>
        <!-- <p-overlayPanel #menuPanel>
            <ng-template pTemplate="content">
               Menu sub items go here
            </ng-template>
        </p-overlayPanel> -->
    </div>

    <div class="user" *ngIf="!isMobile" style="position: relative;" (click)="op.toggle($event)">
        <div class="">
            <img class="logo" [src]="profileUrl" alt="prestige-layout" width="50px;" />
        </div>
        <div class="user-name">
            <div class="">
                <span class="user-profile-name">{{activeUser.first_name}} {{activeUser.last_name}}</span>
            </div>
            <div class="">
                <span class=""><i class="pi pi-chevron-down"></i></span>
            </div>
            <!-- <span class="user-profile-role" *ngIf="viewAsUserName !== ''">Viewing: {{viewAsUserName}}</span> -->
        </div>


        <!-- <ul class="layout-topbar-menu" role="menu">

            <li #profile class="user-profile" role="menuitem"
                [ngClass]="{'active-topmenuitem':app.activeTopbarItem === profile}">
                <a href="#" (click)="app.onTopbarItemClick($event,profile)"
                    [ngStyle]="{'line-height': viewAsUserName !== '' ? '16px' : '44px'}">
                    <div class="user-profile-info profile-link">
                        <span class="user-profile-name">{{activeUser.first_name}} {{activeUser.last_name}}</span>
                        <span class="user-profile-role" *ngIf="viewAsUserName !== ''">Viewing: {{viewAsUserName}}</span>
                    </div>
                    <img class="logo" [src]="profileUrl" alt="prestige-layout" />
                </a>
                <ul class="fadeInDown">
                    <li class="profile-detail">
                        <div class="user-profile-info">
                            <img class="logo" [src]="profileUrl" alt="prestige-layout" />
                            <div class="profile-info">
                                <span class="user-profile-name">{{activeUser.first_name}}
                                    {{activeUser.last_name}}</span>
                            </div>
                        </div>
                    </li>

                    <li *ngIf="viewAsUserName !== ''">
                        <a href="#" (click)="app.onTopbarSubItemClick($event); onReset()">
                            <div class="menu-text">
                                <span class="menu-title">View as Active User</span>
                            </div>
                            <i class="right-icon pi pi-user"></i>
                        </a>
                    </li>

                    <li>
                        <a href="#" (click)="app.onTopbarSubItemClick($event); onLogout($event)">
                            <div class="menu-text">
                                <span class="menu-title">Log out</span>
                            </div>
                            <i class="right-icon pi pi-sign-out"></i>
                        </a>
                    </li>
                </ul>
            </li>
        </ul> -->
    </div>


    <!-- <div class="burger-menu" *ngIf="isMobile">
        <i class="pi pi-bars" style="color: white; font-size: 20px;" (click)="app.onMenuButtonClick($event)"></i>
    </div> -->
    <!-- <a class="layout-menu-button" href="#" (click)="app.onMenuButtonClick($event)"> -->
    <div style="cursor: pointer;" class="layout-menu-button" href="#" (click)="showMobileMenu()">
        <i class="pi pi-bars"></i>
    </div>
</div>
<div class="mobile-menu" *ngIf="isMobileMenuActive">
    <div class="mobile-menu-items" [ngClass]="{'active': isBtnActive[item.routerLink[0]]}"
        *ngFor="let item of model; let i = index;">
        <!-- <button pButton class="mobile-menu-item" [label]="item.label" [icon]="item.icon" size="small"
            (click)="menuItemSelected(item)"></button> -->
        <div class="mobile-menu-item" (click)="menuItemSelected(item)">
            <div class=""
                style="width: 30px; height: 30px; display: flex; flex-direction: row; justify-content: center; align-items: center;">
                <i [class]="item.icon"></i>
            </div>
            <div class="">
                <span>{{ item.label }}</span>
            </div>
        </div>
    </div>
</div>

<p-overlayPanel #op [style]="{'width': '200px', 'margin-right': '30px'}">
    <ng-template pTemplate="content" style="margin-top: 10px;">
        <!-- <h4>Custom Content</h4> -->
        <div class="user">
            <img class="logo" [src]="profileUrl" alt="prestige-layout" width="40px" style="border-radius: 50%;" />
            <div class="profile-info">
                <span class="user-profile-name">{{activeUser.first_name}}
                    {{activeUser.last_name}}</span>
            </div>
        </div>
        <div class="" *ngIf="viewAsUserName !== ''">
            <a href="#" (click)="app.onTopbarSubItemClick($event); onReset()">
                <div class="menu-text">
                    <span class="menu-title">View as Active User</span>
                </div>
                <i class="right-icon pi pi-user"></i>
            </a>
        </div>
        <div>
            <!-- <div class="user-logout-btn" (click)="app.onTopbarSubItemClick($event); onLogout($event)"> -->
            <div class="user-logout-btn" (click)="app.onTopbarSubItemClick($event); onLogout()">
                <div class="menu-text">
                    <span class="menu-title">Log out</span>
                </div>
                <i class="right-icon pi pi-sign-out"></i>
            </div>
        </div>
    </ng-template>
</p-overlayPanel>

<p-overlayPanel #ab [style]="{'height': '330px', 'background-color': '#2757f2'}">
    <ng-template pTemplate="content" style="margin-top: 10px; background-color: #2757f2">
        <div class="admin-menu-item" *ngFor="let item of adminModel" (click)="ab.toggle($event)" [ngClass]="{'active': isAdminBtnActive[item.routerLink[0]]}" >
            <div (click)="menuItemSelected(item)">
                <!-- <div class=""
                    style="width: 30px; height: 30px; display: flex; flex-direction: row; justify-content: center; align-items: center;">
                    <i [class]="item.icon"></i>
                </div> -->
                <div class="">
                    <span>{{ item.label }}</span>
                </div>
            </div>
        </div>
    </ng-template>
</p-overlayPanel>